import styled from "styled-components";
import {LayoutWrapperDefaultBox} from "./layout-wrapper.default.box";

export const LayoutWrapperWsopBox = styled(LayoutWrapperDefaultBox)`
    position: relative;
    &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;

        background-image: radial-gradient(50% 50% at 55% 55%, ${({theme}) => theme.colors.logoBackground}b0, ${({theme}) => theme.colors.background} 70%);
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        width: 100%;
        height: 100%;
    }
`